import {Component, EventEmitter, Output} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Invoice} from "../invoice";
import {InvoiceService} from "../invoice-service.service";
import {CustomerService} from "../customer-service.service";
import {Customer} from "../customer";

@Component({
  selector: 'app-invoice-form',
  templateUrl: './invoice-form.component.html',
  styleUrls: ['./invoice-form.component.css']
})
export class InvoiceFormComponent {

  invoice: Invoice;
  customerId: string;
  customer: Customer;
  id: string;
  action: string;
  myError: string;
  stop: string;

  @Output() refresh = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService,
    private invoiceService: InvoiceService) {
    this.customerId = route.snapshot.params['customerId'];
    this.action = route.snapshot.params['action'];
    this.id = route.snapshot.params['id'];
    this.myError = "";
    this.stop = "";
    if (this.action.localeCompare("add") == 0) {
      this.invoice = new Invoice();
      this.invoice.paid = 0;
      this.invoice.customerId = route.snapshot.params['customerId'];
    }
  }

  ngOnInit() {
    if (this.action.localeCompare("edit") == 0) {
      this.invoiceService.findById(this.id).subscribe(data => {
        this.invoice = data;
        this.customerService.findById(this.invoice.customerId.toString()).subscribe(data => this.customer = data, error => {this.stop = "1"; this.myError= "Customer not found"})
      }, error => {this.stop = "1"; this.myError= "Invoice not found"});
    }
    if (this.action.localeCompare("add") == 0) {
      this.customerService.findById(this.customerId).subscribe(data => this.customer = data, error => this.myError= "Customer not found")
    }
  }

  onSubmit() {
    if (this.action.localeCompare("add") == 0) {
      this.invoiceService.save(this.invoice, this).subscribe(result => this.gotoInvoiceList(), error => this.refresh.emit());
    } else {
      this.invoiceService.update(this.invoice, this).subscribe(result => this.gotoInvoiceList(), error => this.refresh.emit());
    }
  }

  gotoInvoiceList() {
    this.router.navigate(['/invoices/show/' + this.customerId + "/0"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/invoice-form/invoice-form.component.ts